// ─── Base Paths ──────────────────────────────────────────────────────────────
export const ACTIVITY_TRACKING_BASE_PATH = '/activity-tracking';

export const QR_CODE_ACTIVITY_CATEGORY_PATH = '/qr-code-activity-category';
export const QR_CODE_ACTIVITY_TYPE_PATH = '/qr-code-activity-type';
export const QR_ACTIVITY_REPORT_PATH = '/qr-activity-report';

// ─── Title Keys (i18n) ───────────────────────────────────────────────────────
export const ACTIVITY_TRACKING_TITLE = 'title.activityTracking';

export const QR_CODE_ACTIVITY_CATEGORY_TITLE = 'title.activityTracking.qrCodeActivityCategory';
export const QR_CODE_ACTIVITY_TYPE_TITLE = 'title.activityTracking.qrCodeActivityType';
export const QR_ACTIVITY_REPORT_TITLE = 'title.activityTracking.qrActivityReport';

// ─── Namespace (Permission) ───────────────────────────────────────────────────
export const QR_CODE_ACTIVITY_CATEGORY_NAMESPACE = 'QR-CODE-ACTIVITY-CATEGORY';
export const QR_CODE_ACTIVITY_TYPE_NAMESPACE = 'QR-CODE-ACTIVITY-TYPE';
export const QR_ACTIVITY_REPORT_NAMESPACE = 'QR-ACTIVITY-REPORT';

// ─── Permission Types ─────────────────────────────────────────────────────────
export enum ActivityTrackingPermissionType {
  // QR Code Activity Category
  QR_CATEGORY_READ = 'READ_ANY_QR-CODE-ACTIVITY-CATEGORY',
  QR_CATEGORY_CREATE = 'CREATE_ANY_QR-CODE-ACTIVITY-CATEGORY',
  QR_CATEGORY_UPDATE = 'UPDATE_ANY_QR-CODE-ACTIVITY-CATEGORY',

  // QR Code Activity Type
  QR_TYPE_READ = 'READ_ANY_QR-CODE-ACTIVITY-TYPE',
  QR_TYPE_CREATE = 'CREATE_ANY_QR-CODE-ACTIVITY-TYPE',
  QR_TYPE_UPDATE = 'UPDATE_ANY_QR-CODE-ACTIVITY-TYPE',

  // QR Activity Report
  QR_REPORT_READ = 'READ_ANY_QR-ACTIVITY-REPORT',
}

// ─── Dropdown Options ─────────────────────────────────────────────────────────
export const ACCESSIBILITY_OPTIONS = [
  { displayName: 'All', value: '' },
  { displayName: 'Internal', value: 'Internal' },
  // { displayName: 'External', value: 'External' },
];

export const HOST_BY_OPTIONS = [
  { displayName: 'All', value: 'All' },
  { displayName: 'Agency', value: 'Agency' },
  { displayName: 'FTA', value: 'FTA' },
  { displayName: 'Other', value: 'OTHER' },
];

export const channelRoleMatrix: Record<string, string[]> = {
  ['All']: ['AG', 'MOA', 'ADM', 'GAD'],
  ['Agency']: ['AG', 'MOA', 'ADM', 'GAD'],
  ['FTA']: ['AG', 'MOA', 'ADM'],
  ['OTHER']: ['AG', 'MOA', 'ADM', 'GAD'],
};

export const FRAMEWORK_OPTIONS = [
  { displayName: 'All', value: '' },
  { displayName: 'Individual', value: 'Individual' },
  { displayName: 'Group', value: 'Group' },
  { displayName: '1-1', value: '1-1' },
];

export const STATUS_OPTIONS = [
  { displayName: 'All', value: '' },
  { displayName: 'Active', value: 'Active' },
  { displayName: 'In-Active', value: 'In-Active' },
];
